import React from 'react';
import PropTypes from 'prop-types';
import ChevronLeftIcon from '../../../icons/ChevronLeftIcon';
import ChevronRightIcon from '../../../icons/ChevronRightIcon';
import Dictionary from '../../../model/Dictionary';
import { Paper, IconButton, Typography } from 'material-ui';
import './PassengerNavigator.css';

const PassengerNavigator = ({ passenger, passengerNavigation }) => (
  <div className='passenger-navigator'>
    <IconButton onClick={() => passengerNavigation('-')}>
      <ChevronLeftIcon color='rgba(0, 0, 0, 0.54)' />
    </IconButton>

    <Paper className='passenger-info'>
      <Typography type='title' color='inherit' className='left'>
        {`${passenger.firstName} ${passenger.lastName}`}
      </Typography>
      <Typography type='title' color='inherit' className='right'>
        {passenger.seatPreview ? (
          <span>
            {Dictionary.seat.seat}&nbsp;{passenger.seatPreview}
          </span>
        ) : (
          <span>{Dictionary.seat.select}</span>
        )}
      </Typography>
    </Paper>

    <IconButton onClick={() => passengerNavigation('+')}>
      <ChevronRightIcon color='rgba(0, 0, 0, 0.54)' />
    </IconButton>
  </div>
);

PassengerNavigator.propTypes = {
  passengerNavigation: PropTypes.func,
  passenger: PropTypes.object,
};

export default PassengerNavigator;



// WEBPACK FOOTER //
// ./src/components/seats/passengerNavigator/PassengerNavigator.js